import clsx from 'clsx';
import React from 'react';
import { FiRotateCcw, FiX } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import styles from './playgroundHeader.module.scss';


type PlaygroundTypeProps = {
  label: string;
};

export const PlaygroundType = ( { label }: PlaygroundTypeProps ) => {
  return (
    <span>{ label }</span>
  );
};

type PlaygroundInfoProps = {
  backHref: string;
  name: string;
  onReset: () => void;
  version?: string;
};

export const PlaygroundInfo = ( {
  backHref,
  name,
  onReset,
  version = 'unversioned'
}: PlaygroundInfoProps ) => {
  return (
    <>
      <span className={ styles.playground_info_name }>
        <p>{ name }</p>
      </span>
      <span className={ clsx( 'version', styles.playground_info_version ) }>
        { version }
      </span>
      <span className={ styles.playground_info_actions }>
        <span className={ styles.action_button } onClick={ onReset } >
          <FiRotateCcw /> reset
        </span>
        <Link
          className={ styles.action_button }
          to={ backHref }
        >
          <><FiX />go back</>
        </Link>
      </span>
    </>
  );
};